module.exports = __webpack_public_path__ + "media/images/konintodoke/konintodoke-printout-check-list-icon-840748dc851718dd21042787a29d7f9a.png";